'use strict'

export default class Methods {
    constructor() {
        this.content = $('.contentMethods');
        this.createEvents();
        this.hide();
    }
    getContent() {
        return this.content;
    }
    createEvents() {
        this.content.find('.btn_content').each((i,e) => {
            $(e).click(() => {
                const part = $(e).attr('data-target-index');
                window.staticEvents.emit('navigate',`methods/${part}`);
            });
        });
    }
    hide() {
        this.content.detach();
    }
    show(index) {
        this.content.insertBefore('.questions');
        this.content[0].style.display = 'flex';
        const targetClass = `methods_${index}`; 
        const targets = this.content.find(`.methods_s.${targetClass}`);
        const nonTargets = this.content.find(`.methods_s:not(.${targetClass})`);
        const speed1 = 0;
        const speed2 = 550;
        targets.show();
        nonTargets.hide();
        this.content.find('.sub2_s.last').removeClass('last');
        targets.last().addClass('last');
        $('.sub1_s').removeClass('active');
        $(`.sub1_s.sub1_${index}`).addClass('active');
    }
}
